<script setup>
import { useAttrs } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');
</script>

<template>
  <template v-if="globalConfig.logoThumbnail">
    <img v-bind="attrs" :src="globalConfig.logoThumbnail" class="dark:hidden" />
    <img
      v-bind="attrs"
      :src="globalConfig.logoDark || globalConfig.logoThumbnail"
      class="hidden dark:block"
    />
  </template>
  <svg
    v-else
    v-once
    v-bind="attrs"
    width="16"
    height="16"
    viewBox="0 0 28 27"
    fill="currentColor"
    shape-rendering="crispEdges"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="11" y="1" width="1" height="1" />
    <rect x="15" y="1" width="1" height="1" />
    <rect x="7" y="2" width="1" height="1" />
    <rect x="10" y="2" width="6" height="1" />
    <rect x="19" y="2" width="1" height="1" />
    <rect x="7" y="3" width="13" height="1" />
    <rect x="6" y="4" width="14" height="1" />
    <rect x="3" y="5" width="12" height="1" />
    <rect x="18" y="5" width="3" height="1" />
    <rect x="4" y="6" width="1" height="1" />
    <rect x="9" y="6" width="5" height="1" />
    <rect x="20" y="6" width="2" height="1" />
    <rect x="23" y="6" width="2" height="1" />
    <rect x="3" y="7" width="1" height="1" />
    <rect x="6" y="7" width="2" height="1" />
    <rect x="10" y="7" width="3" height="1" />
    <rect x="16" y="7" width="2" height="1" />
    <rect x="20" y="7" width="3" height="1" />
    <rect x="3" y="8" width="1" height="1" />
    <rect x="5" y="8" width="1" height="1" />
    <rect x="7" y="8" width="2" height="1" />
    <rect x="10" y="8" width="3" height="1" />
    <rect x="17" y="8" width="2" height="1" />
    <rect x="21" y="8" width="2" height="1" />
    <rect x="1" y="9" width="3" height="1" />
    <rect x="5" y="9" width="4" height="1" />
    <rect x="10" y="9" width="3" height="1" />
    <rect x="14" y="9" width="5" height="1" />
    <rect x="21" y="9" width="3" height="1" />
    <rect x="26" y="9" width="1" height="1" />
    <rect x="2" y="10" width="3" height="1" />
    <rect x="6" y="10" width="2" height="1" />
    <rect x="9" y="10" width="4" height="1" />
    <rect x="15" y="10" width="4" height="1" />
    <rect x="20" y="10" width="7" height="1" />
    <rect x="2" y="11" width="4" height="1" />
    <rect x="8" y="11" width="6" height="1" />
    <rect x="16" y="11" width="2" height="1" />
    <rect x="20" y="11" width="7" height="1" />
    <rect x="2" y="12" width="13" height="1" />
    <rect x="19" y="12" width="7" height="1" />
    <rect x="1" y="13" width="6" height="1" />
    <rect x="14" y="13" width="11" height="1" />
    <rect x="2" y="14" width="3" height="1" />
    <rect x="10" y="14" width="2" height="1" />
    <rect x="14" y="14" width="12" height="1" />
    <rect x="2" y="15" width="2" height="1" />
    <rect x="9" y="15" width="1" height="1" />
    <rect x="12" y="15" width="1" height="1" />
    <rect x="21" y="15" width="6" height="1" />
    <rect x="2" y="16" width="2" height="1" />
    <rect x="9" y="16" width="1" height="1" />
    <rect x="11" y="16" width="2" height="1" />
    <rect x="22" y="16" width="5" height="1" />
    <rect x="1" y="17" width="3" height="1" />
    <rect x="10" y="17" width="2" height="1" />
    <rect x="22" y="17" width="1" height="1" />
    <rect x="3" y="18" width="2" height="1" />
    <rect x="6" y="18" width="1" height="1" />
    <rect x="10" y="18" width="1" height="1" />
    <rect x="15" y="18" width="1" height="1" />
    <rect x="19" y="18" width="1" height="1" />
    <rect x="21" y="18" width="2" height="1" />
    <rect x="4" y="19" width="2" height="1" />
    <rect x="7" y="19" width="1" height="1" />
    <rect x="12" y="19" width="1" height="1" />
    <rect x="16" y="19" width="1" height="1" />
    <rect x="20" y="19" width="2" height="1" />
    <rect x="4" y="20" width="3" height="1" />
    <rect x="13" y="20" width="1" height="1" />
    <rect x="19" y="20" width="4" height="1" />
    <rect x="4" y="21" width="1" height="1" />
    <rect x="6" y="21" width="3" height="1" />
    <rect x="17" y="21" width="3" height="1" />
    <rect x="22" y="21" width="1" height="1" />
    <rect x="7" y="22" width="12" height="1" />
    <rect x="7" y="23" width="1" height="1" />
    <rect x="10" y="23" width="7" height="1" />
    <rect x="19" y="23" width="1" height="1" />
    <rect x="10" y="24" width="1" height="1" />
    <rect x="13" y="24" width="1" height="1" />
    <rect x="16" y="24" width="1" height="1" />
    <rect x="10" y="25" width="1" height="1" />
    <rect x="13" y="25" width="1" height="1" />
    <rect x="16" y="25" width="1" height="1" />
  </svg>
</template>
